import {useApi} from "../Api";
import {CommercialCategoryEntityResponse} from "../types/commercialCategory";

export const useCommercialCategoryRepository = () => {
    const {GET} = useApi();

    const PATH = "/pricing/commercial-category";

    function getCommercialCategory(id: string): Promise<CommercialCategoryEntityResponse> {
        return GET(`${PATH}?id=${id}`);
    }

    function getCommercialCategories(): Promise<CommercialCategoryEntityResponse[]> {
        return GET(`${PATH}/list`);
    }

    function getCommercialCategoriesByCommercialSegmentId(idCommercialSegment: string): Promise<CommercialCategoryEntityResponse[]> {
        return GET(`${PATH}/category-by-segment?idCommercialSegment=${idCommercialSegment}`);
    }

    return {
        getCommercialCategories,
        getCommercialCategoriesByCommercialSegmentId
    };
};